import ApplicationStatus from '@sunbit-dev/common/enums/cardApply/ApplicationStatus';
import { DocumentTypesTypes } from '@sunbit-dev/common/enums/DocumentTypes';
import { createSelector } from 'reselect';
import { StateType } from '../reducers';

export const selectIsLoading = createSelector(
  (state: StateType) => state.loader,
  (loader) => loader.isLoading
);

export const selectUrlPath = createSelector(
  (state: StateType) => state.router,
  (router) => router.location.pathname
);

export const selectError = createSelector(
  (state: StateType) => state.error,
  (error) => error
);

export const selectInitialDetails = createSelector(
  (state: StateType) => state.initialDetails,
  (initialDetails) => initialDetails
);

export const selectLandingDetails = createSelector(
  (state: StateType) => state.applicationLanding,
  (landingDetails) => landingDetails
);

export const selectIdentificationErrorCode = createSelector(
  (state: StateType) => state.identification,
  (identification) => identification && identification.error && identification.error.code
);

export const selectApplicationDetails = createSelector(
  (state: StateType) => state.applicationDetails,
  (applicationDetails) => applicationDetails
);

export const selectPlasticAddress = createSelector(
  (state: StateType) => state.applicationDetails,
  (applicationDetails) => applicationDetails.plasticAddress
);

export const selectCustomerPhone = createSelector(
  (state: StateType) => state.applicationDetails,
  (applicationDetails) => applicationDetails.customerPhone
);

export const selectShowPlasticAddressModal = createSelector(
  (state: StateType) => state.plasticAddress,
  (plasticAddress) => plasticAddress.showPlasticAddressModal
);

export const selectShowWelcomerPopup = createSelector(
  (state: StateType) => state.welcomerPopup,
  (welcomerPopup) => welcomerPopup.showWelcomerPopup
);

export const selectApplicationStatus = createSelector(
  (state: StateType) => state.applicationDetails,
  (applicationDetails) => applicationDetails.applicationStatus || ApplicationStatus.INITIAL
);

export const selectMilitaryLendingAct = createSelector(
  (state: StateType) => state.existingPaymentMethods,
  (existingPaymentMethods) => existingPaymentMethods.existingPaymentMethods.isMla || false
);

export const selectaccountCreationDate = createSelector(
  (state: StateType) => state.applicationDetails,
  (applicationDetails) => applicationDetails.accountCreationDate || ''
);

export const selectCreditLineDetails = createSelector(
  (state: StateType) => state.creditLine,
  (creditLine) => creditLine
);

export const selectExistingPaymentMethods = createSelector(
  (state: StateType) => state.existingPaymentMethods,
  (existingPaymentMethods) => existingPaymentMethods.existingPaymentMethods
);

export const selectLocationSearch = createSelector(
  (state: StateType) => state.router.location.search,
  (search) => search
);

export const selectDocumentContent = createSelector(
  (state: StateType) => state.document.content,
  (content) => content
);

export const selectApplicationDocumentSolicitaionAgreement = createSelector(
  (state: StateType) => state.applicationDocuments.documents[DocumentTypesTypes.CardApplicationSolicitationDisclosures],
  (document) => (document ? document.content : undefined)
);

export const selectApplicationCreditScoreNotice = createSelector(
  (state: StateType) => state.applicationDocuments.documents[DocumentTypesTypes.CardApplicationCreditScoreNotice],
  (document) => document
);

export const selectApplicationDocumenRecurringPaymentAuthorization = createSelector(
  (state: StateType) =>
    state.applicationDocuments.documents[DocumentTypesTypes.CardApplicationRecurringPaymentAuthorization],
  (document) => (document ? document.content : 'data:text/html;charset=utf-8;base64,Lg==') // return an empty html to avoid breaking
);

export const selectVerificationLink = createSelector(
  (state: StateType) => state.verification.verificationLink,
  (verificationLink) => verificationLink
);
